import { render, staticRenderFns } from "./presentation-file-svg.vue?vue&type=template&id=50741298&scoped=true&"
var script = {}
import style0 from "./presentation-file-svg.vue?vue&type=style&index=0&id=50741298&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50741298",
  null
  
)

export default component.exports